import { useState } from "react";
import { MessageSquareReply } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { FormDialog } from "./FormDialog";

const TONE = { Approved: "bg-emerald-50 text-emerald-700", "Changes requested": "bg-amber-50 text-amber-700", Other: "bg-zinc-100 text-zinc-600" };
const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

export function ClientReplies({ a, onLogged }) {
  const [open, setOpen] = useState(false);
  const replies = a.client_replies || [];
  const save = async (f) => {
    try {
      await api.post(`/approvals/${a.id}/client-reply`, f);
      toast.success(`Client reply logged: ${f.reply}`);
      onLogged();
      return true;
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); return false; }
  };
  return (
    <div className="mt-3" data-testid={`client-replies-${a.id}`}>
      {replies.length > 0 && (
        <div className="mb-2 space-y-1.5">
          <div className="text-[11px] uppercase tracking-wider text-slate-400">Client replies on WhatsApp</div>
          {[...replies].reverse().map((r) => (
            <div key={r.id} data-testid={`client-reply-${r.id}`} className="rounded-md border border-zinc-100 p-2 text-xs">
              <div className="flex flex-wrap items-center gap-2">
                <span className={`rounded px-1.5 py-0.5 font-semibold ${TONE[r.reply]}`}>{r.reply === "Approved" ? "Approved on WhatsApp" : r.reply}</span>
                <span className="text-zinc-400">{r.received_on} · logged by {r.logged_by}</span>
              </div>
              {r.note && <div className="mt-1 whitespace-pre-wrap text-zinc-600">{r.note}</div>}
            </div>
          ))}
        </div>
      )}
      <Button data-testid={`client-reply-log-${a.id}`} size="sm" variant="ghost" className="h-7 px-2 text-zinc-600" onClick={() => setOpen(true)}>
        <MessageSquareReply className="mr-1 h-3.5 w-3.5" />Log client reply
      </Button>
      <FormDialog testid={`client-reply-form-${a.id}`} open={open} onOpenChange={setOpen} title="Log client's WhatsApp reply" submitLabel="Save reply"
        initial={{ reply: "Approved", received_on: today() }}
        fields={[{ name: "reply", label: "Client said", type: "select", options: ["Approved", "Changes requested", "Other"], required: true },
          { name: "received_on", label: "Received on", type: "date" },
          { name: "note", label: "What the client wrote (optional)", type: "textarea" }]} onSubmit={save} />
    </div>
  );
}
